import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setLoginModal } from "../../../../reduxToolkit/reducers/layoutSlice";
import CloseBtn from "../../../commonComponents/CloseBtn";
import LoginForm from "../common/LoginForm";

const LoginModal = () => {
  const { loginModal } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();

  const toggle = () => dispatch(setLoginModal());

  return (
    <Modal centered fade modalClassName="theme-modal" isOpen={loginModal} toggle={toggle}>
      <ModalHeader toggle={toggle} close={<CloseBtn toggle={toggle} />} />
      <ModalBody>
        <LoginForm />
      </ModalBody>
    </Modal>
  );
};

export default LoginModal;
